<template>
    <div>
        <v-container grid-list-xs fluid>
            <v-card>
                <dynamic-toolbar title="Safety Meetings" :loading="loading.lists" color="indigo" icon="mdi-note-search"
                    theme="dark">
                </dynamic-toolbar>
                <v-container grid-list-xs fluid>
                    <v-data-table :headers="headers" :items="sft" :search="search" dense hide-details>
                        <template v-slot:top>
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field label="Search" v-model="search" dense hide-details></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-btn @click="openAdd" color="secondary"
                                        icon><v-icon>mdi-plus-circle</v-icon></v-btn>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.Name="{item}">
                            <v-text-field @change="saveName(item)" v-model="item.Name" dense hide-details></v-text-field>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
            <sft_meeting v-if="opnSftMeeting" :opnSftMeeting="opnSftMeeting" @close="opnSftMeeting = false;"
                @closeUpd="sftMeeting()"></sft_meeting>
        </v-container>
    </div>
</template>
<script>
function logErr(error) {
    console.log(error);
}
import axios from 'axios';
import DateRangeMenu from '@/components/Global/Utils/DateRangeMenu.vue';
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';
import sft_meeting from '@/components/Modals/Catalogs/Docs/SftMeeting.vue';
// import { method } from 'lodash';
export default {
    components: {
        DynamicToolbar,
        DateRangeMenu,
        sft_meeting,
    },
    data: () => ({
        loading: {
            lists: false,
            cost: false,
            dateRangeTotalCost: false,
            totalCostByType: false,
            totalCostByEquipment: false,
            totalCostByCategory: false,
            totalCostBySubcategory: false,
            report: false
        },
        headers: [
            { text: 'id', value: 'SftMeetingId' },
            { text: 'Region', value: 'PrincipalRegion' },
            { text: 'Safety Meeting', value: 'Name' },
        ],
        search: '',
        sft: [],
        opnSftMeeting: false,
    }),
    methods: {
        openAdd: function () {
            this.opnSftMeeting = true;
        },
        sftMeeting() {
            this.loading.lists = true;
            axios
                .get('safety-meeting', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.sft = response.data;
                })
                .catch(error => {
                    logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                });
        },
        saveName: function (item) {
            var parms = {
                Name: item.Name,
            }
            var str =  this.$store;
            str.state.isLoading = true;
            axios
                .put('safety-meeting/'+ item.SftMeetingId, parms,{
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    
                    str.dispatch('setSnackbar', {
                    color: 'success',
                    text:'Changes successfully saved'
                });
                })
                .catch(error => {
                    logErr(error);
                })
                .finally(() => {
                    str.state.isLoading = false;
                });
        },
        opnAddSftMtng: function () {

        }
    },
    mounted() {
        this.sftMeeting();
    },
}

</script>